import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNfcComponent } from './simple-icons-nfc.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNfcComponent ],
    exports:      [ SimpleIconsNfcComponent ],
    bootstrap:    []
})
export class SimpleIconsNfcModule {}
